import { render, staticRenderFns } from "./StoreRGPDForm.vue?vue&type=template&id=7839e72f&"
import script from "./StoreRGPDForm.vue?vue&type=script&lang=js&"
export * from "./StoreRGPDForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports